// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_BigInt from "../Data.BigInt/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var EncDecWrap = function (x) {
    return x;
};
var newtypeEncDecWrap_ = {
    Coercible0: function () {
        return undefined;
    }
};
var encodeJsonEncDecWrapMap = function (dictEncodeJson) {
    var encodeJsonTuple = Data_Argonaut_Encode_Class.encodeJsonTuple(dictEncodeJson);
    return function (dictEncodeJson1) {
        return {
            encodeJson: (function () {
                var $61 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonArray(encodeJsonTuple(dictEncodeJson1)));
                return function ($62) {
                    return $61(toUnfoldable(unwrap($62)));
                };
            })()
        };
    };
};
var encodeJsonEncDecWrapBigIn = {
    encodeJson: /* #__PURE__ */ (function () {
        var $63 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
        return function ($64) {
            return $63(Data_BigInt.toNumber(unwrap($64)));
        };
    })()
};
var decodeJsonEncDecWrapMap = function (dictDecodeJsonField) {
    var gDecodeJsonCons = Data_Argonaut_Decode_Class.gDecodeJsonCons(dictDecodeJsonField);
    return function (dictDecodeJsonField1) {
        var decodeJson = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonCons(dictDecodeJsonField1)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(valueIsSymbol)()())(keyIsSymbol)()())()));
        return function (dictOrd) {
            return {
                decodeJson: (function () {
                    var $65 = map((function () {
                        var $67 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                        var $68 = map1(function (v) {
                            return new Data_Tuple.Tuple(v.key, v.value);
                        });
                        return function ($69) {
                            return wrap($67($68($69)));
                        };
                    })());
                    return function ($66) {
                        return $65(decodeJson($66));
                    };
                })()
            };
        };
    };
};
var decodeJsonEncDecWrapBigIn = {
    decodeJson: /* #__PURE__ */ (function () {
        var $70 = map(wrap);
        var $71 = Control_Bind.bindFlipped(Data_Either.bindEither)((function () {
            var $74 = Data_Either.note(new Data_Argonaut_Decode_Error.TypeMismatch("Not a number"));
            return function ($75) {
                return $74(Data_BigInt.fromNumber($75));
            };
        })());
        var $72 = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonNumber);
        return function ($73) {
            return $70($71($72($73)));
        };
    })()
};
var visonumEncoding$prime = function (tagKey) {
    return {
        tagKey: tagKey,
        valuesKey: "payload",
        unwrapSingleArguments: true
    };
};
var visonumEncoding = /* #__PURE__ */ visonumEncoding$prime("tag");
var genericEncodeJsonVisonum$prime = function (dictGeneric) {
    var genericEncodeJsonWith = Data_Argonaut_Encode_Generic.genericEncodeJsonWith(dictGeneric);
    return function (constructorName) {
        return function (dictEncodeRep) {
            return genericEncodeJsonWith(dictEncodeRep)(visonumEncoding$prime(constructorName));
        };
    };
};
var genericEncodeJsonVisonum = function (dictGeneric) {
    var genericEncodeJsonWith = Data_Argonaut_Encode_Generic.genericEncodeJsonWith(dictGeneric);
    return function (dictEncodeRep) {
        return genericEncodeJsonWith(dictEncodeRep)(visonumEncoding);
    };
};
var genericDecodeJsonVisonum$prime = function (dictGeneric) {
    var genericDecodeJsonWith = Data_Argonaut_Decode_Generic.genericDecodeJsonWith(dictGeneric);
    return function (dictDecodeRep) {
        var genericDecodeJsonWith1 = genericDecodeJsonWith(dictDecodeRep);
        return function (constructorName) {
            return genericDecodeJsonWith1(visonumEncoding$prime(constructorName));
        };
    };
};
var genericDecodeJsonVisonum = function (dictGeneric) {
    var genericDecodeJsonWith = Data_Argonaut_Decode_Generic.genericDecodeJsonWith(dictGeneric);
    return function (dictDecodeRep) {
        return genericDecodeJsonWith(dictDecodeRep)(visonumEncoding);
    };
};
export {
    EncDecWrap,
    genericDecodeJsonVisonum,
    genericDecodeJsonVisonum$prime,
    genericEncodeJsonVisonum,
    genericEncodeJsonVisonum$prime,
    newtypeEncDecWrap_,
    encodeJsonEncDecWrapMap,
    decodeJsonEncDecWrapMap,
    encodeJsonEncDecWrapBigIn,
    decodeJsonEncDecWrapBigIn
};
//# sourceMappingURL=index.js.map
